export const CARD_SCOPES = Object.freeze({
    ALL: 'all',
    BOOKMARKED: 'bookmarked',
});

export const CARD_ASSESSMENTS = Object.freeze({
    CORRECT: {
        id: 3,
        name: 'correct',
        order: 0,
    },
    UNSURE: {
        id: 2,
        name: 'unsure',
        order: 1,
    },
    INCORRECT: {
        id: 1,
        name: 'incorrect',
        order: 2,
    },
    NOT_ASSESSED: {
        id: 0,
        name: 'not_assessed',
        order: 4,
    },
    HIDDEN: {
        id: 4,
        name: 'hidden',
        order: 3,
    },
});

export const CARD_ASSESSMENT_STYLES = Object.freeze({
    CORRECT: {
        icon: 'icon-checkmark-outlined',
        background: 'bg-green-500',
        text: 'text-green-500',
    },
    UNSURE: {
        icon: 'icon-approximately',
        background: 'bg-orange-300',
        text: 'text-orange-300',
    },
    INCORRECT: {
        icon: 'icon-incorrect',
        background: 'bg-red-600',
        text: 'text-red-600',
    },
    HIDDEN: {
        icon: 'icon-visibility-off',
        background: 'bg-black',
        text: 'text-black',
    },
});

export const CARD_SIDES = Object.freeze({
    TERM: 'term',
    DEFINITION: 'definition',
});

export const STUDY_ORDERS = Object.freeze({
    ORIGINAL: 'original',
    RANDOM: 'random',
});

export function getAssessmentById(id) {
    return Object.values(CARD_ASSESSMENTS).find((ass) => ass.id === id);
}
